<template>
    <form @submit.prevent="handleSubmit">
        <div id="content-to-pdf" class="pdf-container web-container-mode" ref="amortizationContent">
            <!-- Primera página con encabezado completo -->
            <div class="page">
                <div class="container-fluid tb-amortization">
                    <!-- Encabezado simplificado -->
                    <div class="row">
                        <div class="col-6" style="text-align: left;">
                            <img width="100" height="51" :src="amortizationStore.logo" />
                        </div>
                        <div class="col-6" style="text-align: right; font-size: 12px;">
                            <strong>Anexo B</strong>
                        </div>
                    </div>

                    <!-- Información del cliente (SOLO PRIMERA PÁGINA) -->
                    <div class="row">
                        <div class="col-12 title-doc">
                            <p>TABLA DE AMORTIZACIÓN</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <table class="table table-bordered mt-2" style="font-size: 11px; font-weight: bold;">
                                <tbody>
                                    <tr>
                                        <td>Cliente:</td>
                                        <td>{{ getName(amortizationStore?.selectedApplication) }}</td>
                                    </tr>
                                    <tr>
                                        <td>Número de Contrato:</td>
                                        <td>{{
                                            amortizationStore?.selectedApplication?.product?.productContract?.referenceNumber
                                            || '' }}</td>
                                    </tr>
                                    <tr>
                                        <td>Número de Acréditado:</td>
                                        <td>{{ amortizationStore?.selectedApplication?.prospectus?.referenceNumber || ''
                                            }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- Tabla principal -->
                    <div class="row">
                        <div class="col-12">
                            <table class="table table-bordered mt-4 pdf-table" style="font-size: 10px;">
                                <thead>
                                    <tr>
                                        <th scope="col" class="content-center">#</th>
                                        <th scope="col" class="content-center">Fecha</th>
                                        <th scope="col" class="content-center">Saldo</th>
                                        <th scope="col" class="content-center">Capital</th>
                                        <th scope="col" class="content-center">Interés</th>
                                        <th scope="col" class="content-center">IVA</th>
                                        <th scope="col" class="content-center">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template
                                        v-if="amortizationStore?.selectedApplication?.quotations?.quotationsReferenceNumber?.length > 0">
                                        <tr v-for="(amortization, index) in firstPageRows"
                                            :key="amortization.loanAmortizationsId">
                                            <th scope="row" class="content-center">{{ index + 1 }}</th>
                                            <td class="content-center">{{ $filters.formatDateView(amortization.dueDate)
                                            }}</td>
                                            <td class="content-center">{{
                                                $filters.formatNumber(amortization.initialCapital) }}</td>
                                            <td class="content-center">{{ $filters.formatNumber(amortization.capital) }}
                                            </td>
                                            <td class="content-center">{{ $filters.formatNumber(amortization.interest)
                                            }}</td>
                                            <td class="content-center">{{ $filters.formatNumber(amortization.tax) }}
                                            </td>
                                            <td class="content-center">{{
                                                $filters.formatNumber(amortization.installmentWithVat) }}</td>
                                        </tr>
                                    </template>
                                    <tr v-else>
                                        <td colspan="7" style="text-align: center;">{{
                                            $getLocaleMessage('common', 'noDataFound') }}</td>
                                    </tr>
                                </tbody>
                                <!-- Tfoot solo en la última página si no hay más filas -->
                                <tfoot v-if="remainingRows.length === 0">
                                    <tr>
                                        <th scope="row" colspan="3" class="content-center">Total</th>
                                        <td class="content-center">{{
                                            $filters.formatNumber(amortizationStore?.selectedApplication?.quotations?.amortizationTotals?.capital)
                                            || ''
                                        }}</td>
                                        <td class="content-center">{{
                                            $filters.formatNumber(amortizationStore?.selectedApplication?.quotations?.amortizationTotals?.interest)
                                            ||
                                            '' }}</td>
                                        <td class="content-center">{{
                                            $filters.formatNumber(amortizationStore?.selectedApplication?.quotations?.amortizationTotals?.installmentWithVat)
                                            || '' }}</td>
                                        <td class="content-center">{{
                                            $filters.formatNumber(amortizationStore?.selectedApplication?.quotations?.amortizationTotals?.totalInstallment)
                                            || '' }}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    <!-- Firma solo en la última página si no hay más filas -->
                    <div v-if="remainingRows.length === 0" class="row">
                        <div class="col-12 content-center" style="padding-top: 25px;">
                            <strong>EL ACREDITADO</strong>
                        </div>
                        <div class="col-12 content-center" style="padding-top: 50px;">
                            ___________________________________
                        </div>
                        <div class="col-12 content-center">
                            <strong>{{ getName(amortizationStore?.selectedApplication) }}</strong>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Páginas adicionales -->
            <div v-for="(pageRows, pageIndex) in additionalPages" :key="pageIndex" class="page">
                <div class="container-fluid tb-amortization">
                    <!-- Encabezado simplificado -->
                    <div class="row">
                        <div class="col-6" style="text-align: left;">
                            <img width="100" height="51" :src="amortizationStore.logo" />
                        </div>
                        <div class="col-6" style="text-align: right; font-size: 12px;">
                            <strong>Anexo B (continuación)</strong>
                        </div>
                    </div>

                    <!-- Tabla para esta página -->
                    <div class="row">
                        <div class="col-12">
                            <table class="table table-bordered mt-4 pdf-table" style="font-size: 10px;">
                                <thead>
                                    <tr>
                                        <th scope="col" class="content-center">#</th>
                                        <th scope="col" class="content-center">Fecha</th>
                                        <th scope="col" class="content-center">Saldo</th>
                                        <th scope="col" class="content-center">Capital</th>
                                        <th scope="col" class="content-center">Interés</th>
                                        <th scope="col" class="content-center">IVA</th>
                                        <th scope="col" class="content-center">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(amortization, index) in pageRows"
                                        :key="amortization.loanAmortizationsId">
                                        <th scope="row" class="content-center">{{ firstPageRows.length + (pageIndex *
                                            rowsPerPage) +
                                            index + 1 }}</th>
                                        <td class="content-center">{{ $filters.formatDateView(amortization.dueDate) }}
                                        </td>
                                        <td class="content-center">{{ $filters.formatNumber(amortization.initialCapital)
                                        }}</td>
                                        <td class="content-center">{{ $filters.formatNumber(amortization.capital) }}
                                        </td>
                                        <td class="content-center">{{ $filters.formatNumber(amortization.interest) }}
                                        </td>
                                        <td class="content-center">{{ $filters.formatNumber(amortization.tax) }}</td>
                                        <td class="content-center">{{
                                            $filters.formatNumber(amortization.installmentWithVat) }}</td>
                                    </tr>
                                </tbody>
                                <!-- Tfoot y firma solo en la última página -->
                                <tfoot v-if="pageIndex === additionalPages.length - 1">
                                    <tr>
                                        <th scope="row" colspan="3" class="content-center">Total</th>
                                        <td class="content-center">{{
                                            $filters.formatNumber(amortizationStore?.selectedApplication?.quotations?.amortizationTotals?.capital)
                                            || '' }}</td>
                                        <td class="content-center">{{
                                            $filters.formatNumber(amortizationStore?.selectedApplication?.quotations?.amortizationTotals?.interest)
                                            || '' }}</td>
                                        <td class="content-center">{{
                                            $filters.formatNumber(amortizationStore?.selectedApplication?.quotations?.amortizationTotals?.installmentWithVat)
                                            || '' }}</td>
                                        <td class="content-center">{{
                                            $filters.formatNumber(amortizationStore?.selectedApplication?.quotations?.amortizationTotals?.totalInstallment)
                                            || '' }}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    <!-- Firma solo en la última página -->
                    <div v-if="pageIndex === additionalPages.length - 1" class="row">
                        <div class="col-12 content-center" style="padding-top: 25px;">
                            <strong>EL ACREDITADO</strong>
                        </div>
                        <div class="col-12 content-center" style="padding-top: 50px;">
                            ___________________________________
                        </div>
                        <div class="col-12 content-center">
                            <strong>{{ getName(amortizationStore?.selectedApplication) }}</strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-actions">
            <button class="download-btn">Descargar PDF</button>
        </div>
    </form>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useAmortizationStore } from '@/pinia/LoanApplications/Legal/useAmortizationStore.module';

const amortizationStore = useAmortizationStore();
const amortizationContent = ref(null);
const rowsPerPage = 35; // Ajustar según pruebas

const getName = (item) => {
    if (item === null) {
        return '';
    } else {
        if (item.prospectus?.generalInfo?.businessName === null) {
            return `${item.prospectus?.generalInfo?.firstName} ${item.prospectus?.generalInfo?.lastName} ${item.prospectus?.generalInfo?.mothersMaidenName}`;
        } else {
            return `${item.prospectus?.generalInfo?.businessName}`;
        }
    }
}

// Computed para dividir las filas en páginas
const amortizationRows = computed(() => {
    return amortizationStore?.selectedApplication?.quotations?.loanAmortizations || [];
});

const firstPageRows = computed(() => {
    return amortizationRows.value.slice(0, rowsPerPage);
});

const remainingRows = computed(() => {
    return amortizationRows.value.slice(rowsPerPage);
});

const additionalPages = computed(() => {
    const pages = [];
    for (let i = 0; i < remainingRows.value.length; i += rowsPerPage) {
        pages.push(remainingRows.value.slice(i, i + rowsPerPage));
    }
    return pages;
});

const handleSubmit = () => {
    amortizationStore.setContent(amortizationContent.value);
    amortizationStore.downloadPDF();
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    text-indent: 0;
}

#content-to-pdf {
    overflow: visible;
    font-family: Calibri, sans-serif;
    color: #000 !important;
}

.pdf-container.web-container-mode * {
    font-size: 12px !important;
}

.page {
    padding: 20px;
    background-color: white;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    margin-bottom: 25px;
    page-break-after: always;
}

.page:last-child {
    page-break-after: auto;
}

.download-btn {
    padding: 10px 20px;
    background-color: #42b983;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    margin-top: 20px;
    transition: background-color 0.3s;
}

.download-btn:hover {
    background-color: #369f6e;
}

.title-doc {
    font-weight: bold;
    font-size: 12px;
    text-align: center !important;
}

.title-doc p {
    padding-top: 15px;
    padding-bottom: 15px;
}

.content-center {
    text-align: center;
}

.pdf-table {
    border-collapse: collapse !important;
    border-spacing: 0 !important;
    width: 100%;
    margin-bottom: 0;
    /* Elimina margen inferior para pegar tfoot */
}

.pdf-table th,
.pdf-table td {
    border: 1px solid #000 !important;
    padding: 4px;
}

thead,
tfoot {
    background-color: #d8d8d8;
    font-weight: bold;
}

/* Estilo para mantener tfoot pegado al último tr */
.pdf-table tbody tr:last-child td {
    border-bottom: none;
}

.pdf-table tfoot tr:first-child {
    border-top: 2px solid #000;
}

.tb-amortization .table td,
.tb-amortization .table th {
    padding: 2px;
}

.tb-amortization td {
    padding: 0px 6px 0px 6px !important;
    border: 1px solid #000 !important;
}
</style>